// extracted by mini-css-extract-plugin
module.exports = {"title":"CardLongSkeleton__title__1K6mS","description":"CardLongSkeleton__description__h50uO","footer":"CardLongSkeleton__footer__3cTkJ"};